<template>
    <div class="content mt20">
        <div class="account-content bgfff">
            <dataAnalysisMenu></dataAnalysisMenu>
        </div>
        <div class="account-bd">&nbsp;</div>
        <div class="account-content bgfff" style="position:relative">
            <div class="one-bd clearfix">
                <div class="fl">
                    <router-link to="/wxdataAnalysis" exact>我的业绩</router-link>
                    <router-link to="/wxdataAnalysis/myFans">我的粉丝</router-link>
                    <router-link to="/wxdataAnalysis/myArticle">我的文章</router-link>
                </div>
                <div class="btn-warp fr">
                    <button class="btn btn-blue" @click="selectPublic"><i class="icons jiaohu-icon"></i>选择其他媒体号</button>
                </div>
            </div>
            <div class="select-public" :class="(Active?'':'hide')" id="ghList">
                <div class="select-warp">
                    <div class="close fr" @click="closeModal"><img src="/static/images/close.png" ></div>
                    <div class="one-bd clearfix">
                        <div class="search fl">
                            <input type="text" v-model="sel" class="input-text" name="search" placeholder="请输入用户名/手机号">
                        </div>
                        <button class="btn btn-blue" @click="searchButton"><i class="icons search-icon"></i></button>
                    </div>
                    <div class="gh-warp clearfix mt20" id="ghWarpList">
                        <div class="img-word" v-for="(item,index) in selectPList" :key="index" @click="clickPublic(item.id)">
                            <img :src="item.headImg" class="img"/>
                            <div class="word">
                                <div class="in">
                                    <span class="name db">{{item.nickname}}</span>
                                    <span class="en-name db">{{item.alias}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="xinxi-header mt30 clearfix">
                <div class="img-word fl">
                    <img :src="wxInfo.headImg" class="img"/>
                    <i class="icons wx-icon"></i>
                    <div class="word">
                        <div class="in">
                            <span class="name">{{wxInfo.nickname}}</span>
                            <span class="en-name">{{wxInfo.alias}}</span>
                        </div>
                    </div>
                </div>
                <div class="rank-item  clearfix fl">
                    <div class="item fl">
                        <span class="rank-num db">{{wxInfo.rank}}</span>
                        <span class="rank-word db">总排名 <span :class="[{'color-red':parseInt(wxInfo.rankUp)>0},{'cr1ab968':parseInt(wxInfo.rankUp)<0},{'color-gray':parseInt(wxInfo.rankUp)==0}]"><i class="icons" :class="parseInt(wxInfo.rankUp)>0 ? ' icon-up1' : ' icon-down1'" v-if="!wxInfo.rankUp==0"></i>{{wxInfo.rankUp}}</span></span>
                    </div>
                </div>
                
            </div>
       </div>
       <div class="account-bd">&nbsp;</div>
       <div class="bgfff">
            <div class="bd clearfix">
                <div class="title fl">{{dateOne}} 粉丝分析</div>
                <div class="update-button ml20 fr" @click="updateData" v-if="(datetype != 'week'&&datetype !='month')"><i class="icons icon-update"></i>更新数据</div>
                <div class="w194 ml25 form-time fr" v-if="(datetype != 'week'&&datetype !='month')">
                    <vue-datepicker-local v-model="timeRange" format="YYYY-MM-DD" :disabled-date="disabledDate" showButtons  @confirm="selectedDate"/><i class="icons date-icon fr"></i>
                </div>
                <div class="dropdown-toggle w194 ml25 fr" v-if="(datetype == 'week')">
                    <div class="dropdown" >
                        <span >{{dateOne}}</span>
                        <i class="icons icons-down fr"></i>
                    </div>
                    <div class="drop-down w194">
                        <ul class="dropdown-menu dropdown-menu1" role="menu">
                            <li v-for="(item,index) in dateWeek" :key="index">
                                <a class="day" :class="(dateOne==item?'active':'')" @click="dateClick(item)">{{item}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="dropdown-toggle w194 ml25 fr" v-if="(datetype == 'month')">
                    <div class="dropdown" >
                        <span >{{dateOne}}</span>
                        <i class="icons icons-down fr"></i>
                    </div>
                    <div class="drop-down w194">
                        <ul class="dropdown-menu dropdown-menu1" role="menu">
                            <li v-for="(item,index) in dateMonth" :key="index">
                                <a class="day" :class="(dateOne==item?'active':'')" @click="dateClick(item)">{{item}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="btns-group time-tab fr">
                    <a :class="(datetype != 'week'&&datetype !='month')?'active':''" @click="dateList('day')" href="javascript:void(0);">日榜</a>
                    <a :class="(datetype == 'week')?'active':''" @click="dateList('week')" href="javascript:void(0);">周榜</a>
                    <a :class="(datetype =='month')?'active':''" @click="dateList('month')" href="javascript:void(0);">月榜</a>
                </div>
            </div>
            <div class="container-body mt20">
                <div class="plane">
                    <div class="plane-header">
                        <ul>
                            <li>业绩状况</li>
                        </ul>
                    </div>
                    <div class="no-data" v-if="nodata"><span class="text">没有数据哦...</span></div>
                    <div class="plane-body clearfix" v-if="!nodata">
                        <div class="left-body mt50 ml30 fl">
                            <ul class="mt50">
                                <li>
                                    <h1 class="color-black">{{wxfans.fansCount}}</h1>
                                    <span class="color-black">粉丝总数</span>
                                </li>
                            </ul>
                        </div>
                        <div class="right-body clearfix">
                            <div class="strip big-screen fl">
                                <div class="item clearfix">
                                    <span class="name fl">新增粉丝</span>
                                    <div class="bar-warp"><span class="bar blue fl"><span class="in pl" :style="'width:'+avg1+'%'"></span></span></div>
                                    <span class="num fl">{{wxfans.subCount}}</span>
                                </div>
                                <div class="item clearfix">
                                    <span class="name fl">取消关注</span>
                                    <div class="bar-warp"><span class="bar lightblue fl"><span class="in pr" :style="'width:'+avg2+'%'"></span></span></div>
                                    <span class="num fl">{{wxfans.unsubCount}}</span>
                                </div>
                                <div class="item clearfix">
                                    <span class="name fl">净增粉丝</span>
                                    <div class="bar-warp"><span class="bar green fl"><span class="in pl" :style="'width:'+avg3+'%'"></span></span></div>
                                    <span class="num fl">{{wxfans.trueSubCount}}</span>
                                </div>
                            </div>
                            <div class="echart fr" id="main">
                                <div class="circle ac">
                                    <p class="fs24 fw7">{{wxfans.eventCount}}</p>
                                </div>
                                <p class="ac">粉丝互动消息数</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="plane mt20">
                    <div class="plane-header">
                        <ul>
                            <li :class="(Current==1?'current':'')" @click="lineChart1(1)">粉丝增长</li>
                            <li :class="(Current==2?'current':'')" @click="lineChart1(2)">粉丝总量</li>
                            <li :class="(Current==3?'current':'')" @click="lineChart1(3)">粉丝来源</li>
                        </ul>
                    </div>
                    <div class="plane-body region-chart clearfix">
                        <div class="no-data" v-if="lineChartData ==''"><span class="text">没有数据哦...</span></div>
                        <lineChart id="lineEchart" :dataArray="lineChartData" v-if="lineChartData !=''" />
                    </div>
                </div>

                <div class="plane mt20">
                    <div class="plane-header">
                        <ul class="fl"> 
                            <li>粉丝列表</li>
                        </ul>
                        <div class="mr20 fr">
                            <a :href="downLoadUrl" download=""><i class="icons download-icon"></i>下载数据</a>
                        </div>
                    </div>
                    <div class="plane-body clearfix">
                        <table class="table ac" width="100%" border="0" cellpadding="0" cellspacing="0">
                            <colgroup>
                                <col width="">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th class="ac"><span class="th-span">粉丝总量</span></th>
                                    <th class="ac"><span class="th-span up">新增粉丝数 <i class="icons sort-icon"></i></span></th>
                                    <th class="ac"><span class="th-span down">取消关注数 <i class="icons sort-icon"></i></span></th>
                                    <th class="ac"><span class="th-span">净增粉丝数 <i class="icons sort-icon"></i></span></th>
                                    <th class="ac"><span class="th-span">粉丝互动消息数 <i class="icons sort-icon"></i></span></th>
                                    <th class="ac">日期</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in mediaList" :key="index">
                                    <td>{{item.fansCount}}</td>
                                    <td>{{item.subCount}}</td>
                                    <td>{{item.unsubCount}}</td>
                                    <td>{{item.trueSubCount}}</td>
                                    <td>{{item.eventCount}}</td>
                                    <td>{{item.resDate}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
       </div>
  	</div>
</template>
<script>
import VueDatepickerLocal from 'vue-datepicker-local'
import lineChart from '@/components/echart/lineChart'
import dataAnalysisMenu from './dataAnalysisMenu.vue'
export default {
    components:{
        VueDatepickerLocal,lineChart,dataAnalysisMenu
    },
    data() {
        return {
           mediaList:[],//微信列表
           wxInfo:[],//微信信息
           wxfans:[],//粉丝状况
           downLoadUrl:[],//下载地址
           currentPage:1,//当前条数
           limit:10,//每页显示条数
           totalCount:0,//总条数
           currentTab:'week',//时间
           //typeCurrent:'day',//选择时间当前类型
           dateWeek:'',//周
           dateMonth:'',//月
           dateOne:'',//默认时间week month
           //dateOne2:'',//默认时间month
           timeRange:'',//默认day
          // time:'',
           //current:false,
            //min: min,
            //max: max,
           // timeRange: [min, max],
            Current:1,
            lineChartData:[],//echart图表数据
            Active:false,
            selectPList:[],//选择公众号列表
            Id:'',//公众号id
            sel:'',//搜索绑定值
            fansSub:'',//新增粉丝
            fansUnsub:'',//取消关注
            fansTrueSub:'',//粉丝京增量
            fansTotal:'',//粉丝总数
            cart:'',//名片分享
            name:'',//公众号名称
            code:'',//图文页菜单
            other:'',//其他
            datetype:'',//日期类型
            avg1:'',
            avg2:'',
            avg3:'',
            nodata:false,
            nodata1:false,

        }
    },
    mounted() {
        let that = this;
        var myDate = new Date();
        myDate.setDate(myDate.getDate() - 1);
        that.timeRange = myDate.toLocaleDateString();

        if(that.$route.query.type==undefined){
            that.currentTab = that.currentTab;
        }else{
            that.currentTab = that.$route.query.type;
        }
        if(that.$parent.mediaId==''){
			that.Id=that.Id;
		}else{
			that.Id=that.$parent.mediaId;
		}
        that.dataAjax();
      //  that.lineChartAjax();
        that.$nextTick(()=> {
            that.lineChartAjax();
        })
        
    },
    created() {
		
    },
    methods: {
        updateData(){//更新数据
            let that = this;
            that.$parent.loadModal(true,'正在加载...');
            that.$api.post('datacube/updatefans',{},r=>{
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    r.msg;
                })
            })

        },
        closeModal(){//关闭公众号弹框
            let that = this;
            that.Active =false;
        },
        searchButton(){//搜索公众号
            let that = this;
            that.selectPublic();
            that.Active =true;
        },
        clickPublic(id){//点击公众号
            let that = this;
            that.Id= that.$parent.mediaId = id;
            that.dataAjax();
            that.Active = !that.Active;
        },
        selectPublic(){//选择公众号
            let that = this;
            that.Active = !that.Active;
            that.$api.post('/member/accountlist',{search:that.sel,type:1},r=>{
                that.$parent.returnCode(r,function(){
                    that.selectPList = r.data.list;
                })
            })


        },
        lineChart1(type){//线性图表点击切换
            let that = this;
            that.Current = type;
            that.lineChartAjax(type);
        },
        lineChartAjax(type){//图表
            let that = this;
            type = that.Current;
            if(type == 1){
                let newData = {
                    "dataName":['粉丝增长','取消关注','净增粉丝'],
                    "粉丝增长":that.fansSub,
                    "取消关注":that.fansUnsub,
                    "净增粉丝":that.fansTrueSub,
                    "datetime":that.datetime
                };
                that.lineChartData = newData;
            }else if(type == 2){
                let newData = {
                    "dataName":['粉丝总量'],
                    "粉丝总量":that.fansTotal,
                    "datetime":that.datetime
                };
                that.lineChartData = newData;
            }else if(type == 3){
                let newData = {
                    "dataName":['名片分享','公众号名称','图文页菜单','其他'],
                    "名片分享":that.cart,
                    "公众号名称":that.name,
                    "图文页菜单":that.code,
                    "其他":that.other,
                    "datetime":that.datetime
                };
                that.lineChartData = newData;
            }
            
        },
        dateClick(type1){//点击时间下拉
            let that = this;
            that.dateOne =type1;
            that.$router.push({
                path: '/wxdataAnalysis/myFans',
                query: {
                    type1: type1
                }
            });
            that.dateOne = that.$route.query.type1;
            that.dataAjax();

        },
        dateList(type){//点击切换 日周月榜
            let that = this;
            that.currentTab = type;
            if(type=='day'){
               that.dateOne = that.timeRange;
            }else if(type=='week'){
                that.dateOne = that.dateWeek[0]
            }else if(type=='month'){
                that.dateOne = that.dateMonth[0]
            }
            that.dataAjax();
            that.$router.push({
                path: '/wxdataAnalysis/myFans?type1='+that.dateOne,
                query: {
                    type: that.currentTab
                }
            });
        },
        disabledDate(time,format){
            let that = this;
           if(time==this.timeRange){
                return false;
            }
        },
        selectedDate(date) {//点击日榜时间确定
            let that = this;
            that.dateOne = that.timeRange = that.$utils.dateConversion(that.timeRange,0);
            that.dataAjax();
        },
        dataAjax(){//微信列表
            let that = this;
            let url = '';
            that.$parent.loadModal(true,'正在加载...');
            that.$api.post('/datacube/wxfans',{dateType:that.currentTab,date:that.dateOne,id:that.Id},r=>{
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){     
                    that.mediaList= r.data.list;
                    that.wxInfo = r.data.info;
                    that.wxfans = r.data.fans;
                    that.downLoadUrl =r.data.downloadUrl;
                    that.fansSub=r.data.fansSub;
                    that.fansUnsub=r.data.fansUnsub;
                    that.fansTrueSub=r.data.fansTrueSub;
                    that.fansTotal=r.data.fansTotal;
                    that.cart=r.data.cart;
                    that.name=r.data.name;
                    that.code=r.data.code;
                    that.other=r.data.other;
                    that.datetime = r.data.date;
                    that.datetype = r.data.type;
                    that.dateWeek = r.data.week;
                    that.dateMonth = r.data.month;
                    that.dateWeek[0] = r.data.week[0];
                    //console.log(that.dateWeek);
                    that.lineChartAjax();
                    if(that.wxfans.length<=0){
                        that.nodata = true;
                    }else{
                        that.nodata = false
                    }
                    if(that.$route.query.type1 == undefined){
                        that.dateOne = that.dateWeek[0]
                    }else{
                        that.dateOne = that.$route.query.type1;
                    }
                    if(r.data.fans.subCount==0){
                        that.avg1 = that.avg2 = that.avg3 =0;
                    }else{
                        that.avg1 = r.data.fans.subCount/r.data.fans.subCount*100>100?'100':r.data.fans.subCount/r.data.fans.subCount*100;
                        that.avg2 = r.data.fans.unsubCount/r.data.fans.subCount*100>100?'100':r.data.fans.unsubCount/r.data.fans.subCount*100;
                        that.avg3 = r.data.fans.trueSubCount/r.data.fans.subCount*100>100?'100':r.data.fans.trueSubCount/r.data.fans.subCount*100;
                    }
              })
            })
       }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/dataAnalysis/myFans.vue